import { Row, Col } from 'src/componentes/grid';

import LinguaLookup from 'src/lookups/LinguaLookup';
import NivelProficienciaLookup from 'src/lookups/NivelProficienciaLookup';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { COLABORADOR_CAMPOS } from 'src/utils/constants';

import { hasSearchMatch } from './searchUtils';

const IdiomasSection = ({ model, intl, campos, searchQuery }) => {
  if (!campos[COLABORADOR_CAMPOS.IDIOMAS]) return null;

  const fieldMatches = (terms) => hasSearchMatch(searchQuery, terms);
  const sectionTerms = [
    intl.formatMessage({ id: 'idiomas' }),
    intl.formatMessage({ id: 'idioma' }),
    intl.formatMessage({ id: 'nivelProficiencia' }),
  ];

  if (!hasSearchMatch(searchQuery, sectionTerms)) return null;

  return (
    <CollapsibleSection title={intl.formatMessage({ id: 'idiomas' })}>
      <Row>
        {fieldMatches([intl.formatMessage({ id: 'idioma' })]) && (
          <Col md={12}>
            <LinguaLookup model={model.getModel('idiomaCadastrado')} clearable />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'nivelProficiencia' })]) && (
          <Col md={12}>
            <NivelProficienciaLookup model={model.getModel('nivelProficiencia')} clearable />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default IdiomasSection;
